import { Injectable } from '@angular/core';
import { HttpMethod } from '@lagoshny/ngx-hateoas-client';
import { Observable } from 'rxjs';
import { CommonState } from 'src/app/shared/services/common-state.service';
import { Note } from '../models/note.model';

@Injectable({
  providedIn: 'root',
})
export class NoteService extends CommonState<Note> {
  constructor() {
    super(Note);
  }

  public findUnreadNotes(): Observable<Note[]> {
    return this.customSearchQuery(HttpMethod.GET, 'findUnreadNotes');
  }

  public findByInspectionIds(ids: string[]): Observable<Note[]> {
    return this.customSearchQuery(HttpMethod.POST, 'findByInspectionIds', { body: { ids: [...new Set(ids)] } });
  }

  public findByScenarioIds(ids: string[]): Observable<Note[]> {
    return this.customSearchQuery(HttpMethod.POST, 'findByScenarioIds', { body: { ids: [...new Set(ids)] } });
  }
}
